import React from "react";
import PropTypes from "prop-types";
import {Col, FormGroup} from "reactstrap";
import DatePicker from "react-datepicker";
import AsteriskIcon from "../../asteriskIcon";
import HelpIcon from "../../HelpIcon/HelpIcon";
import "react-datepicker/dist/react-datepicker.css";

const DateCreator = (props) => {
  const {
    label,
    inSingleRow = false,
    large = false,
    isRequired = false,
    help_text = "",
    value,
    ...rest
  } = props;

  return (
    <Col md={large ? "12" : "6"}>
      <FormGroup row>
        <Col md={inSingleRow ? 3 : 12}>
          <div className="d-flex">
            {label && <label className="form-control-label roboto-bold">{label}</label>}
            {isRequired && <AsteriskIcon />}
            {help_text && (
              <span style={{padding: "0px 5px"}}>
                <HelpIcon text={help_text} target={label} place="right" />
              </span>
            )}
          </div>
        </Col>
        <Col md={inSingleRow ? 9 : 12}>
          <DatePicker selected={value} placeholderText="Select Date" {...rest} />
        </Col>
      </FormGroup>
    </Col>
  );
};

DateCreator.propTypes = {
  /** Value of selected date */
  value: PropTypes.instanceOf(Date),
  /** Label for form field */
  label: PropTypes.string,
  /** Wether to show label and input field in single row */
  inSingleRow: PropTypes.bool,
  /** If this prop is set to true then this component will take 100% width of parent component */
  large: PropTypes.bool,
  /** This prop determines wether form field is required */
  isRequired: PropTypes.bool,
  /** If value is passed for this prop this will be shown as tooltip when hovered on help icon */
  help_text: PropTypes.string,
};

export default DateCreator;
